module.exports = __webpack_public_path__ + "img/top.1982f56c.png";